module.exports = __webpack_public_path__ + "media/images/t-artemis-square-ad385f0719ee3c8f6b938c2bd80f9b71.png";